import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Report from '../../components/report/Report'
import { translate } from 'react-polyglot'
import { fetchWalletList } from '../../actions/reports/walletReport'
import { fetchBuyList } from '../../actions/reports/buyReport'
import { fetchStockList } from '../../actions/reports/stockReport'
import { fetchSaleList } from '../../actions/reports/saleReport'
import { fetchReceiptList } from '../../actions/reports/receiptReport'
import TrackingContainer from '../../containers/tracking/trackingContainer'
import { fetchPowerbiConfig, powerBiRefreshSession } from '../../actions/reports/powerbiReport'
import { fetchReportTypeCode } from '../../actions/reports/report'

export function mapStateToProps (state) {
  return {
    ...state.auth,
    ...state.report,
    powerbiConfig: state.powerbiReport
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchWalletList,
      fetchBuyList,
      fetchStockList,
      fetchSaleList,
      fetchReceiptList,
      fetchPowerbiConfig,
      fetchReportTypeCode,
      powerBiRefreshSession
    }, dispatch)
  }
}

var decoratedComponent = TrackingContainer(Report, true)
export default connect(mapStateToProps, mapDispatchToProps)(translate()(decoratedComponent))
